import { Instance, types } from 'mobx-state-tree';

const ChatProgram = types.model('ChatProgram', {
	id: types.identifierNumber,
	name: types.optional(types.string, ''),
	official_name: types.optional(types.string, ''),
});

export default ChatProgram;

export interface IChatProgramModel extends Instance<typeof ChatProgram> {}
